import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MapPin, Search, CalendarDays, Users } from "lucide-react";
import { DateRangeField, todayRome } from "@/components/DateField";
import { ComuneSearch } from "@/components/ComuneSearch";
import { QueryField } from "@/components/home/QueryField";

const field = "w-full bg-white text-[#0D2B5A] placeholder:text-slate-400 rounded-xl px-4 py-3 text-sm border border-slate-200 focus:border-gold outline-none transition-colors";
const Lbl = ({ icon: Icon, children }) => <label className="flex items-center gap-1.5 text-xs font-display font-semibold text-aic-navy mb-1.5"><Icon className="w-3.5 h-3.5 text-[#C98A3C]"/>{children}</label>;

export const HeroSearch = () => {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [place, setPlace] = useState(() => params.get("lat") ? { name: params.get("comune") || "", prov: params.get("prov") || "", lat: parseFloat(params.get("lat")), lng: parseFloat(params.get("lng")) } : null);
  const [date, setDate] = useState(params.get("date") ? { from: params.get("date"), to: params.get("dateTo") || params.get("date") } : null);
  const [text, setText] = useState(params.get("q") || "");
  const go = (override) => {
    const t = (typeof override === "string" ? override : text).trim();
    const q = new URLSearchParams();
    if (t) q.set("q", t);
    if (place) { q.set("comune", place.name); q.set("prov", place.prov); q.set("lat", place.lat); q.set("lng", place.lng); }
    if (date?.from) { q.set("date", date.from); if (date.to && date.to !== date.from) q.set("dateTo", date.to); }
    nav(`/cerca?${q.toString()}`);
  };
  return (
    <div className="bg-white rounded-2xl shadow-[0_24px_60px_rgba(9,31,66,0.25)] border border-slate-100 p-4 md:p-5 scroll-mt-28" id="cerca" data-testid="hero-search">
      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-[1.4fr_1.1fr_1.1fr_auto] lg:items-end">
        <div>
          <Lbl icon={Users}>Cosa cerchi?</Lbl>
          <QueryField value={text} onChange={setText} onSearch={go} className={field}/>
        </div>
        <div>
          <Lbl icon={MapPin}>Dove?</Lbl>
          <ComuneSearch value={place} onSelect={setPlace} testId="hero-place" inputCls={field}/>
        </div>
        <div>
          <Lbl icon={CalendarDays}>Quando?</Lbl>
          <DateRangeField testId="hero-date" value={date} min={todayRome()} onChange={setDate} placeholder="Qualsiasi data" className={field}/>
        </div>
        <button type="button" data-testid="hero-search-go" onClick={() => go()} className="btn-pill-gold justify-center !rounded-xl py-3 px-8"><Search className="w-4 h-4"/>Cerca</button>
      </div>
      <p className="text-[11px] text-slate-500 mt-2.5">Tutti i campi sono facoltativi: compila solo quelli che ti servono. Senza luogo cerchiamo in tutta Italia.</p>
    </div>
  );
};
